import { ListingMergeSuggestion } from 'src/WebApiController';

/**
 * Clusted array of listing ids when they have overlap
 * E.g. [[1, 2], [3, 4], [2, 3], [5, 6]] => [[1, 2, 3], [5, 6]]
 * @param listingIds
 * @returns
 */
const clusterListingIds = (listingIds: number[][]) => {
  const clusters: number[][] = [];
  // This step is necessary - check the case of [[1, 2], [3, 4], [2, 3]]
  const sortedListingIds = listingIds.toSorted((a, b) => a[0] - b[0]);
  sortedListingIds.forEach((ids) => {
    const cluster = clusters.find((c) => ids.some((id) => c.includes(id)));
    if (cluster) {
      ids.forEach((id) => {
        if (!cluster.includes(id)) {
          cluster.push(id);
        }
      });
    } else {
      clusters.push(ids);
    }
  });
  return clusters
    .map((c) => c.toSorted((a, b) => a - b))
    .filter((c) => c.length > 1);
};

export const clusterListingMergeSuggestionsByListingIdOverlap = (
  mergeSuggestions: ListingMergeSuggestion[] | null | undefined
): ListingMergeSuggestion[] | null | undefined => {
  if (!mergeSuggestions) {
    return mergeSuggestions;
  }

  const mergeSuggestionsByEventIdAndAccountId: Record<
    string,
    ListingMergeSuggestion[]
  > = {};
  mergeSuggestions.forEach((s) => {
    // We first partition by event and account (if applicable) - it's not possible to cluster them
    let key = s.eventId ? s.eventId.toString() : (s.eventMappingId ?? '');

    if (s.accId != null) {
      key += `|${s.accId}`;
    }

    if (!key) return;

    if (!mergeSuggestionsByEventIdAndAccountId[key]) {
      mergeSuggestionsByEventIdAndAccountId[key] = [];
    }
    mergeSuggestionsByEventIdAndAccountId[key].push(s);
  });

  const mergedSuggestions: ListingMergeSuggestion[] = [];

  Object.values(mergeSuggestionsByEventIdAndAccountId).forEach(
    (suggestions) => {
      const listingIds = suggestions.map((s) => s.listingIds);
      const clusteredListingIds = clusterListingIds(listingIds);

      clusteredListingIds.forEach((ids) => {
        const mergedSuggestion: ListingMergeSuggestion = {
          eventId: suggestions[0].eventId,
          eventMappingId: suggestions[0].eventMappingId,
          listingIds: ids,
          seatFrom: null,
          seatTo: null,
          accId: suggestions[0].accId,
        };
        mergedSuggestions.push(mergedSuggestion);
      });
    }
  );

  return mergedSuggestions;
};
